module.exports = __webpack_public_path__ + "3421dbce1157dfe181c5443d487bad6b.svg";